import { SubSink } from 'subsink';
import {
  Component,
  OnInit,
  ViewChild,
  OnDestroy,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';

import { AuthService, AuthUser } from '@monorepo/ui/auth';
import { ChatBotService } from '../../services/chat-bot.service';

import { ChatBotMessage, ChatBotModel } from '../../models';

@Component({
  selector: 'monorepo-user-chat-detail',
  templateUrl: './user-chat-detail.component.html',
  styleUrls: ['./user-chat-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserChatDetailComponent implements OnInit, OnDestroy {
  @ViewChild(CdkVirtualScrollViewport) viewPort: CdkVirtualScrollViewport;
  private subs = new SubSink();
  chatForm: FormGroup;
  chatBotMessage: ChatBotMessage = new ChatBotMessage();
  chatbotDetail: ChatBotModel;
  messageList: ChatBotMessage[] = [];
  isChatbotSelected: boolean = false;
  loggedUser: AuthUser;

  constructor(
    private authService: AuthService,
    private chatBotService: ChatBotService,
    private formBuilder: FormBuilder,
    private cdrRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.chatForm = this.formBuilder.group({
      message: [''],
    });
    this.getAuthUser();
    this.getChatbotDetail();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private getAuthUser(): void {
    this.subs.sink = this.authService.user.subscribe({
      next: (user: AuthUser): void => {
        if (user) {
          this.loggedUser = user;
        }
      },
    });
  }

  private scroll(): void {
    setTimeout(() => {
      let scrollIndex = this.viewPort?.elementRef?.nativeElement;
      this.viewPort?.elementRef?.nativeElement.scrollTo({
        top: scrollIndex.scrollHeight + scrollIndex.scrollTop,
        left: 0,
        behavior: 'auto',
      });
    }, 500);
  }

  public getChatbotDetail(): void {
    this.subs.sink = this.chatBotService.selectedChatbot$.subscribe({
      next: (chatbot: ChatBotModel): void => {
        if (chatbot) {
          this.getChatBot(chatbot.userId);
        }
      },
    });
  }

  public getChatBot(id: string): void {
    this.subs.sink = this.chatBotService.getChatbot(id).subscribe({
      next: (chatbot: ChatBotModel): void => {
        this.chatbotDetail = chatbot;
        this.messageList = chatbot.messages;
        this.isChatbotSelected = true;
        this.cdrRef.detectChanges();
        this.scroll();
      },
    });
  }

  public sendMessage(): void {
    if (!this.chatForm.get('message').value) {
      return;
    }
    this.chatBotMessage.senderId = this.loggedUser.uid;
    this.chatBotMessage.displayName = this.loggedUser.displayName;
    this.chatBotMessage.photoURL = this.loggedUser.photoURL;
    this.chatBotMessage.message = this.chatForm.get('message').value;
    this.chatForm.reset();

    this.chatBotService
      .sendMessage(this.chatbotDetail.id, this.chatBotMessage)
      .then(() => {
        this.getChatbotDetail();
      });
  }
}
